import { RootState } from '@/app/redux/store';
import { generateStudentPassword } from '@/common/utils/student';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Learner {
  firstName: string;
  surname: string;
  username: string;
  password: string;
  passwordVisible: boolean;
}

interface BulkAddState {
  learners: Learner[];
}

// Start with one empty learner
const initialState: BulkAddState = {
  learners: [
    {
      firstName: '',
      surname: '',
      username: '',
      password: generateStudentPassword(),
      passwordVisible: false,
    },
  ],
};

interface UpdateLearnerPayload {
  index: number;
  field: keyof Learner;
  value: string | boolean;
}

const bulkAddSlice = createSlice({
  name: 'bulkAdd',
  initialState,
  reducers: {
    addLearner: (state, action: PayloadAction<Learner>) => {
      state.learners.push(action.payload);
    },
    removeLearner: (state, action: PayloadAction<number>) => {
      state.learners.splice(action.payload, 1);
    },
    updateLearner: (state, action: PayloadAction<UpdateLearnerPayload>) => {
      const { index, field, value } = action.payload;
      if (index >= 0 && index < state.learners.length) {
        if (field === 'passwordVisible' && typeof value === 'boolean')
          state.learners[index][field] = value;
        else if (field !== 'passwordVisible' && typeof value === 'string') {
          state.learners[index][field] = value;
        }
      }
    },
    clearLearners: (state) => {
      state.learners = [];
    },
    resetLearnerState: (state) => {
      state.learners = initialState.learners;
    },
  },
});

export const {
  addLearner,
  removeLearner,
  updateLearner,
  clearLearners,
  resetLearnerState,
} = bulkAddSlice.actions;
export default bulkAddSlice.reducer;

// Selectors
export const selectBulkAdd = (state: RootState) => state.bulkAdd;
